import React from 'react'
import { Link } from 'react-router-dom'
import abimg from '../../images/resource/business-1.jpg'
import abimg2 from '../../images/resource/business-2.jpg'
import bg1 from '../../images/background/pattern-21.png'


const Business = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }

    return (
        <section className="business-one" id='about'>
            <div className="auto-container">
                <div className="row clearfix">
                    <div className="business-one_content-column col-lg-6 col-md-12 col-sm-12">
                        <div className="business-one_content-inner">
                            <div className="sec-title title-anim">
                                <div className="sec-title_title">Become Clear & Connected</div>
                                <h2 className="sec-title_heading">A Community Where Work & Well-Being Meet</h2>
                            </div>
                            <div className="business-one_bold-text">Try new things. Share what works. Be real. Grow together.</div>
                            <div className="business-one_text">We bring together founders, operators, and creators to learn by doing—peer-powered circles, SkillSwap micro-sessions, and mindful pauses that turn conversations into clarity and next steps.</div>
                            <div className="business-one_feature">
                                <div className="business-one_feature-icon flaticon-tourist"></div>
                                <strong>Signature Circles</strong>
                                Curated, invite-only groups for real talk, feedback, and warm intros that move your work forward.
                            </div>
                            <div className="business-one_feature">
                                <div className="business-one_feature-icon flaticon-leader"></div>
                                <strong>SkillSwap Socials</strong>
                                Hands-on, peer-led mini sessions—swap tools, frameworks, and playbooks you can use tomorrow.
                            </div>

                            {/* <div className="business-one_button">
                                <Link onClick={ClickHandler} to="/event-details/Registration-For-Opening-Workshop" className="theme-btn btn-style-one">
                                    <span className="btn-wrap">
                                        <span className="text-one">Claim Your Invite</span>
                                        <span className="text-two">Claim Your Invite</span>
                                    </span>
                                </Link>
                            </div> */}

                        </div>
                    </div>
                    <div className="business-one_image-column col-lg-6 col-md-12 col-sm-12">
                        <div className="business-one_image-inner">
                            <div className="business-one_pattern-one" style={{ backgroundImage: `url(${bg1})` }}></div>
                            <div className="business-one_experiance">
                                <div className="business-one_counter"><span className="odometer" data-count="35"></span>Join Now</div>
                                <i>The Most Aligned</i>
                                <strong>Community</strong>
                            </div>
                            <div className="business-one_image">
                                <img src={abimg} alt="" />
                            </div>
                            <div className="business-one_image-two">
                                <img src={abimg2} alt="" />
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}

export default Business;